<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-aprovacao-filtro @change="emitChange"/>
      <px-search-text label="Busque por um fornecedor ou produto"
                      class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange"/>
  </div>
</template>

<script>
import ListagemAprovacoesFiltro from './ListagemAprovacoesFiltro.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    selectedStatus: {
      get() {
        return this.$store.getters['listagemAprovacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemAprovacao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemAprovacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemAprovacao/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: ['APROVADO'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['PENDENTE'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: ['RECUSADO'],
        },
      ],
    };
  },
  components: {
    pxListagemAprovacaoFiltro: ListagemAprovacoesFiltro,
  },
};
</script>
